module.exports = __webpack_public_path__ + "static/Copernicus-Book-089769f8c85059e4deecd8994e58d8c2.woff2";